export default "__VITE_ASSET__DOmRUgzF__"